module.exports = __webpack_public_path__ + "img/fill2.6a01fa40.svg";